import {
    AccordionContainerDPC,
    AccordionDPC,
    AllegatoContainerDPC,
    AllegatoDPC,
    PageContainerDPC,
    LinksContainerDPC,
    LinksDPC,
    PrintButtonDPC
} from '@dpc-fe/shared';
import {graphql} from 'gatsby';
import React from 'react';
import {getSlug, getAccordionAndTabLinks} from "../functions/functions";
import {prop} from "../functions/functions";


export default ({data, pageContext}) => {

    const language = '/' + pageContext.lang;
    const correlazioniTypes = ['comunicato_stampa','notizia','approfondimento','pubblicazione', 'corso', 'pagina', 'sezione'];

    const fotoVideoTypes = ['galleria_foto','galleria_flickr','video'];

    const correlazioni = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria == null || correlazioniTypes.indexOf(item.field_categoria_primaria) > -1).map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +item.field_categoria_primaria.charAt(0).toUpperCase() + item.field_categoria_primaria.replace(/_/g, ' ').slice(1)+'</b>' : '<b>Sezione</b>') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_IO_NON_RISCHIO, item.relationships.field_sottodominio.name)
      }   
    });

    const fotoVideo = data.node.relationships.field_correlazioni.filter(item => fotoVideoTypes.indexOf(item.field_categoria_primaria) > -1).map(item => {
      return {
          title: (item.field_categoria_primaria === 'video' ? '<b>Video</b>' : '<b>Foto</b>') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_IO_NON_RISCHIO, item.relationships.field_sottodominio.name)
      }   
    });

    const bandoDiGara = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria === 'bando_di_gara').map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +item.field_categoria_primaria.charAt(0).toUpperCase() + item.field_categoria_primaria.replace(/_/g, ' ').slice(1)+'</b>' : '') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_IO_NON_RISCHIO, item.relationships.field_sottodominio.name)
      }   
    });

    const mappe = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria === 'mappa').map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +item.field_categoria_primaria.charAt(0).toUpperCase() + item.field_categoria_primaria.replace(/_/g, ' ').slice(1)+'</b>' : '') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_IO_NON_RISCHIO, item.relationships.field_sottodominio.name)
      }   
    });

    const timeline = data.node.relationships.field_correlazioni.filter(item => item.field_categoria_primaria === 'timeline').map(item => {
      return {
          title: (item.field_categoria_primaria ? '<b>' +item.field_categoria_primaria.charAt(0).toUpperCase() + item.field_categoria_primaria.replace(/_/g, ' ').slice(1)+'</b>' : '') + ' - ' + item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_IO_NON_RISCHIO, item.relationships.field_sottodominio.name)
      }   
    });

  const normative = data.node.relationships.field_normative.map(item => {
      return {
          title: item.field_titolo_esteso,
          slug: getSlug(language + item.fields.slug, process.env.MINISITO_IO_NON_RISCHIO, item.relationships.field_sottodominio.name)
      }
  });

  const linkEsterni = data.node.field_link_esterni ? data.node.field_link_esterni.map(item => {
      return {
          title: item.title,
          titleLinkEsterno: "Val al sito " + item.uri,
          slug: item.uri
      }
  }) : [];

  const breadcrumbItem = {
    name: data.node.field_titolo_esteso,
    slug: data.node.fields && data.node.fields.slug ? data.node.fields.slug : null,
    active: true
}
    return (
        <PageContainerDPC
            menuItems={pageContext.menu}
            slugTraduzione={data.node.relationships.field_riferimento_traduzione ? data.node.relationships.field_riferimento_traduzione.fields.slug : ''}
            pageId={data.node.drupal_internal__nid}
            title={data.node.title}
            env={process.env.ENV}
            lang={pageContext.lang}
            basePathNavbar={process.env.MINISITO_IO_NON_RISCHIO_URL}
            minisiti={prop}
            breadcrumbItem={!!data.node?.path?.alias ? null : breadcrumbItem}
            immagineShare={data.node.relationships?.field_immagine_dettaglio ? process.env.MINISITO_IO_NON_RISCHIO_URL + data.node.relationships?.field_immagine_dettaglio?.relationships?.image?.localFile?.publicURL: process.env.MINISITO_IO_NON_RISCHIO_URL + pageContext.socialImg?.relationships?.image?.localFile?.publicURL}
            abstractShare={data.node.body?.processed ? data.node.body.processed.replace(/<\/?[^>]+(>|$)/g, "") : ''}
            slug={process.env.MINISITO_IO_NON_RISCHIO_URL + '/' + pageContext.lang + data.node.fields.slug}
            menuFooterItems={pageContext.menuFooter}
            isIoNonRischio={true}
        >
        <div className="container">
                <div className="px-custom">
                    <div className="row">
                        <div className="col-12">
                            <article>
                                <h1>{data.node.field_titolo_esteso}</h1>
                                <div style={{fontStyle: 'italic'}} dangerouslySetInnerHTML={{__html: data.node.field_abstract?.processed}}/>
                                <div dangerouslySetInnerHTML={{__html: data.node.body?.processed}}/>
                                <div className="iframe-map-embed embed-responsive embed-responsive-custom">
                                    <iframe id="mapFrame" src={data.node.field_link_mappa?.uri} className="embed-responsive-item" title={data.node.field_titolo_esteso} allowFullScreen={true}/>
                                </div>
                                <div dangerouslySetInnerHTML={{__html: data.node.field_descrizione_mappa?.processed}}/>
                                {(data.node.relationships.field_accordion && data.node.relationships.field_accordion.length > 0) &&
                                <AccordionContainerDPC id="1">
                                    {data.node.relationships.field_accordion
                                        .map((node, index) => (
                                            <AccordionDPC
                                                title={node.field_titolo ? node.field_titolo : ''}
                                                body={node.field_testo ? node.field_testo.value : ''}
                                                id={index}
                                                accordionId={"1"}
                                                img={node.relationships.field_immagine}
                                                tabella={node.field_tabella?.processed}
                                                video={node.relationships.field_video}
                                                links={node.relationships ? getAccordionAndTabLinks(node.relationships.field_link_interni, pageContext.lang, process.env.MINISITO_IO_NON_RISCHIO) : null}
                                            />))}
                                </AccordionContainerDPC>
                                }
                                <section className="attachments-and-links">
                                    {Array.isArray(data.node.relationships.field_allegati) &&
                                    data.node.relationships.field_allegati.length > 0 &&
                                    <AllegatoContainerDPC titoloSezione={'Allegati'}>
                                        {
                                            data.node.relationships.field_allegati.map(allegato => (
                                                <AllegatoDPC
                                                    titolo={allegato.field_titolo_esteso}
                                                    descrizione={allegato.relationships?.field_allegato?.description}
                                                    dimension={allegato.relationships?.field_allegato?.filesize}
                                                    slug={allegato.relationships?.field_allegato?.localFile?.publicURL}
                                                    extension={allegato.relationships?.field_allegato?.localFile?.extension}
                                                />
                                            ))
                                        }
                                    </AllegatoContainerDPC>
                                    }
                                    {normative && normative.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Normativa'}>
                                        <LinksDPC links={normative}/>
                                    </LinksContainerDPC>}

                                    {bandoDiGara && bandoDiGara.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Avvisi e bandi di gara'}>
                                        <LinksDPC links={bandoDiGara}/>
                                    </LinksContainerDPC>}

                                    {correlazioni && correlazioni.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Per saperne di più'}>
                                        <LinksDPC links={correlazioni}/>
                                    </LinksContainerDPC>}

                                    {fotoVideo && fotoVideo.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Foto e video'}>
                                        <LinksDPC links={fotoVideo}/>
                                    </LinksContainerDPC>}                                  

                                    {mappe && mappe.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Mappe'}>
                                        <LinksDPC links={mappe}/>
                                    </LinksContainerDPC>}

                                    {timeline && timeline.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Timeline'}>
                                        <LinksDPC links={timeline}/>
                                    </LinksContainerDPC>}

                                    {linkEsterni && linkEsterni.length > 0 &&
                                    <LinksContainerDPC titoloSezione={'Link esterni'}>
                                    	<LinksDPC links={linkEsterni}/>
                                    </LinksContainerDPC>}
                                </section>
                                <PrintButtonDPC/>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </PageContainerDPC>
    );
};


export const query = graphql`
query($slug: String!) {
    node:nodeMappa(fields: { slug: { eq: $slug } }) {
      field_categoria_primaria

      body {
        processed
        value
      }
      fields {
        slug
      }
      field_abstract {
        processed
        value
      }
      drupal_internal__nid
      field_link_esterni {
      title
      uri
    }
      title
      field_titolo_esteso
      field_data
      field_link_mappa {
        title
        uri
      }
      field_descrizione_mappa {
        processed
        value
      }
      field_url_legenda {
        title
        uri
      }
      relationships {
        field_sottodominio {
          name
        }
        field_immagine_dettaglio {
          field_alt
          field_didascalia
          field_titolo_esteso
          relationships {
            image:field_immagine{
              localFile {
			    publicURL
                childImageSharp {
                  fluid(maxWidth: 1100) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
          }
          }
        }
        field_riferimento_traduzione {
          fields{
            slug
          }
        }
        field_correlazioni {
                    ...pubblicazioneFragment
            ...notiziaFragment
            ...approfondimentoFragment
            ...normativaFragment
            ...pageFragment
            ...bandoDiGaraFragment
            ...comunicatoStampaFragment
            ...corsoFragment
            ...mappaFragment
            ...timelineFragment
            ...sezioneConAnticipazioniFragment
            ...sezioneSenzaAnticipazioniFragment
            ...elencoApprofondimentiFragment
            ...elencoGlossariFragment
            ...elencoAttualitaFragment
            ...elencoPodcastFragment
            ...elencoPubblicazioniFragment
            ...elencoNormativaFragment
            ...elencoBandiEContrattiFragment
            ...elencoFotoVideoFragment
...elencoWebinarFragment
            ...homepageVolontariatoFragment
            ...homepageRelazioniFragment
            ...homepageRischiFragment
            ...homepageNazionaleFragment
            ...homepageMappeFragment
            ...homepageGiovaniFragment
            ...homepageFormazioneFragment
            ...homepageEventiFragment
            ...homepageEmergenzeFragment
            ...homepageDocsFragment
            ...homepageDomandeFragment
...homepagePnrrFragment
...homepageItAlertFragment
...homepageIononrischioFragment
...homepageInrAttimoDecisivoFragment
            ...homepagePortaleFragment
            ...bollettinoCriticitaFragment
            ...bollettinoVigilanzaFragment
            ...sezioneAllertaMeteoIdroFragment
            ...galleriaFotoFragment
            ...galleriaFlickrFragment
            ...videoFragment
...webinarFragment
...videolezioniFragment
...elencoVideolezioniFragment
      }
        field_normative {
            ...normativaFragment
        }
        field_accordion {
          field_titolo
          field_testo {
            processed
            value
          }
          field_tabella {
            processed
            value
          }
          relationships {
            field_immagine {
              id
              field_alt
              field_didascalia
              relationships {
                image:field_immagine{
              localFile {
			    publicURL
                childImageSharp {
                      fluid(maxWidth: 1100) {
                        ...GatsbyImageSharpFluid_noBase64
                      }
                    }
                  }
                }
              }
            }
            field_video {
              ...videoFragment
            ...webinarFragment
...videolezioniFragment
            }
          }
        }
        field_allegati {
          field_titolo_esteso
          relationships {
            field_allegato {
              localFile {
                publicURL
                size
                extension
              }
              filesize
            }
            field_sottodominio {
              name
            }
          }
        }
      }
    }
}
`;
